// SVG and HTML are left out on purpose: opened from a blob URL they would run
// script in our origin, and uploads are not trusted.
const PREVIEW_TYPES = {
  'application/pdf': 'pdf',
  'text/plain': 'text',
  'image/jpeg': 'image',
  'image/png': 'image',
  'image/webp': 'image',
  'image/gif': 'image',
};

const EXTENSION_TYPES = {
  pdf: 'application/pdf',
  txt: 'text/plain',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
  gif: 'image/gif',
};

/**
 * The MIME type a trip document can safely be shown as, or null when the
 * browser can't display it (Word files, HEIC photos, unknown types).
 */
export const getPreviewMimeType = (document_) => {
  const mimeType = String(document_?.mime_type || '').toLowerCase().split(';')[0].trim();
  if (PREVIEW_TYPES[mimeType]) return mimeType;

  const extension = String(document_?.file_name || '').toLowerCase().split('.').pop();
  return EXTENSION_TYPES[extension] || null;
};

export const getPreviewKind = (document_) => {
  const mimeType = getPreviewMimeType(document_);
  return mimeType ? PREVIEW_TYPES[mimeType] : null;
};
